<template>
  <!--
    Without this a card can only ever report growth: a row that left has no
    line to be drawn on and would go unmentioned.
  -->
  <p v-if="departed.length > 0" class="tw:mt-2 tw:mb-0 tw:text-xs tw:text-zinc-500">
    {{ $t('No longer present:') }}
    {{ departed.map((row) => `${row.label} (${$t('was {share}', { share: Math.round(row.share) + '%' })})`).join(', ') }}
  </p>
</template>

<script setup lang="ts">
defineProps<{
  departed: { label: string, share: number }[]
}>();
</script>
